import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-go-to-catalog';
export var ID = 'icon-go-to-catalog';
/* eslint-disable max-len */

export var SVGGoToCatalog = function SVGGoToCatalog() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 66 54"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "go_to_catalog",
    transform: "translate(-6.000000, -11.000000)"
  }, React.createElement("rect", {
    x: "0",
    y: "0",
    width: "76",
    height: "76"
  }), React.createElement("path", {
    d: "M14.017,19 L14.017,12 L32.7,12 L37.798,20 L70.017,20 L70.017,59 L70.017,60.279 C70.017,62.326 68.406,64 66.435,64 C64.339,64 63.017,62.326 63.017,60.279 L63.017,58.108 L63.017,59 L63.017,58.108 L63.017,27 L30.798,27 L25.7,19 L7.017,19 L7,59.9999416 C7,62.2159416 8.801,64.0099416 11.017,63.9999416 L66.139,64",
    stroke: "#6D6565",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M34.017,36.9999416 L54.017,36.9999416 L34.017,36.9999416 Z",
    stroke: "#6D6565",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M34.017,44.9999416 L54.017,44.9999416 L34.017,44.9999416 Z",
    stroke: "#6D6565",
    strokeWidth: "2"
  }), React.createElement("path", {
    d: "M34.017,52.9999416 L54.017,52.9999416 L34.017,52.9999416 Z",
    stroke: "#6D6565",
    strokeWidth: "2"
  }))));
};
/* eslint-disable max-len */

var GoToCatalog = function GoToCatalog(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGGoToCatalog
  });
};

GoToCatalog.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default GoToCatalog;